// src/pages/yachts/special-offers/components/OffersTable.js
import React from 'react';
import { Table, Button, Badge } from 'reactstrap';
import moment from 'moment';

import { offerTypeLabel, audienceLabel } from '../validate';

function discountSummary(offer) {
    switch (offer.offer_type) {
        case 'percentage':
            return `${offer.discount_percent}%`;
        case 'flat_amount':
            return `${(offer.discount_amount_currency || '').toUpperCase()} ${offer.discount_amount}`;
        case 'free_days':
            return `+${offer.free_days} free day(s)`;
        case 'tiered_discount':
            return `Tiered (${(offer.tiers || []).length} tiers)`;
        case 'package':
            return `Package (${(offer.tiers || []).length} tiers)`;
        default:
            return offer.offer_type;
    }
}

function audienceColor(audience) {
    if (audience === 'broker_restricted') return 'warning';
    if (audience === 'authenticated') return 'info';
    return 'success';
}

const OffersTable = ({ offers, isAdmin, onEdit, onArchive, yachtId }) => {
    if (!offers || offers.length === 0) {
        return (
            <div className="text-center mt-4 mb-4">
                <p style={{ color: '#41506e' }}>
                    {isAdmin
                        ? 'No offers yet. Click "+ New offer" to create one.'
                        : 'No offers available for this yacht.'}
                </p>
            </div>
        );
    }

    return (
        <Table responsive striped>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Charter window</th>
                    <th>Discount</th>
                    <th>Audience</th>
                    <th>Status</th>
                    {isAdmin && <th>Actions</th>}
                </tr>
            </thead>
            <tbody>
                {offers.map((offer) => (
                    <tr key={offer.id}>
                        <td>{offer.name}</td>
                        <td>{offerTypeLabel(offer.offer_type)}</td>
                        <td>
                            {moment(offer.date_from).format('YYYY-MM-DD')} →{' '}
                            {moment(offer.date_to).format('YYYY-MM-DD')}
                            {!!offer.allow_partial_application && (
                                <>
                                    {' '}
                                    <Badge
                                        color="info"
                                        title="Applies to the booked days inside this window only"
                                    >
                                        Partial
                                    </Badge>
                                </>
                            )}
                        </td>
                        <td>{discountSummary(offer)}</td>
                        <td>
                            <Badge color={audienceColor(offer.audience)}>
                                {audienceLabel(offer.audience)}
                            </Badge>
                        </td>
                        <td>
                            {offer.is_active ? (
                                <Badge color="success">Active</Badge>
                            ) : (
                                <Badge color="secondary">Inactive</Badge>
                            )}
                        </td>
                        {isAdmin && (
                            <td>
                                <div className="so-actions">
                                    <Button
                                        size="sm"
                                        color="primary"
                                        onClick={() => onEdit(offer.id)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() => {
                                            if (
                                                window.confirm(
                                                    'Archive this offer? This cannot be undone — to bring it back, create a new offer.'
                                                )
                                            ) {
                                                onArchive(offer.id);
                                            }
                                        }}
                                    >
                                        Archive
                                    </Button>
                                </div>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default OffersTable;
